import { render, staticRenderFns } from "./ProductTable.vue?vue&type=template&id=002d8432"
import script from "./ProductTable.ts?vue&type=script&lang=ts&external"
export * from "./ProductTable.ts?vue&type=script&lang=ts&external"
import style0 from "./ProductTable.vue?vue&type=style&index=0&id=002d8432&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
